import { Component, Inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Announcement } from '@icc/shared/helpers';
import { DIALOG_DATA, DialogRef } from '@icc/ui';

@Component({
    selector: 'icc-announcement-preview',
    templateUrl: './announcement-preview.component.html',
    styleUrls: ['./announcement-preview.component.scss'],
})
export class AnnouncementPreviewComponent {

    announcementContent: SafeHtml = null;

    constructor(
        @Inject(DIALOG_DATA) public data: {
            announcement: Announcement;
        },
        private dialogRef: DialogRef,
        private domSanitizer: DomSanitizer,
    ) {
        this.announcementContent = this.domSanitizer.bypassSecurityTrustHtml(this.data.announcement.bodyRichtext);
    }

    close() {
        this.dialogRef.close();
    }
}
